// F3-1 三图1
import clsx from 'clsx'
import { FC } from 'react'
import { IMutipleMedia, paddingTopClassMap, paddingBottomClassMap } from '@/common/pd-meta-components-types'
import PdMedia from '@/components/pd-media/pd-media'
import { useMobileDetector } from '@/hooks/use-mobile-detector'
import TitleAndDesc from '../../title-and-desc'
import TagItem from '../../tag-item'

const MainAndTwoSubMedia: FC<IMutipleMedia> = ({ theme, title, desc, mediaGroup = [], mediaBorderRadius = 0, paddingTop = 'px120', paddingBottom = 'px120' }) => {
  const isMobile = useMobileDetector()

  return (
    <div className={clsx('w-full h-fit', paddingTopClassMap[paddingTop], paddingBottomClassMap[paddingBottom], `pd-theme-${theme}`, 'bg-container-primary')}>
      <div className={clsx('w-full max-w-300 mx-auto')}>
        <TitleAndDesc title={title} desc={desc} />
        <div className={clsx('grid grid-cols-1 gap-8', 'laptop:grid-cols-2 laptop:gap-4', 'px-6 laptop:px-0')}>
          {mediaGroup?.map((item, index) => (
            <div className={clsx('relative', index === 0 ? 'laptop:col-span-2' : 'laptop:col-span-1')} key={item.title}>
              <div
                className={clsx('w-full overflow-hidden', 'h-358px laptop:h-fit', 'mb-3 laptop:mb-0')}
                style={{ aspectRatio: index === 0 ? '2/1' : '4/3', borderRadius: `${mediaBorderRadius}px` }}
              >
                <PdMedia
                  src={isMobile ? item.mediaH5Url || item.mediaUrl || '' : item.mediaUrl || ''}
                  mask={false}
                  className="hover:scale-110 transition-all ease-in-out duration-[800ms]"
                />
              </div>
              <div
                className={clsx(
                  'laptop:absolute laptop:top-0 laptop:left-0 laptop:inset-0 laptop:p-6 laptop:pointer-events-none'
                )}
              >
                <TagItem title={item.title} desc={item.desc} />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default MainAndTwoSubMedia
